module.exports = __webpack_public_path__ + "img/paystack_edited.cf37508f.png";